import './App.css';
import { BrowserRouter } from 'react-router-dom';
import Paths from './Paths';
import {Helmet} from "react-helmet"
import Logo from "../src/Assets/Logo-full.png"
import { useRef } from 'react';
import UserContext from './Context';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function App() {
  const mycontactref=useRef(null)
  console.log(mycontactref)
  return (
    // <div className="App">
    //   <header className="App-header">
    //     <img src={logo} className="App-logo" alt="logo" />
    //     <p>
    //       Edit <code>src/App.js</code> and save to reload.
    //     </p>
    //     <a
    //       className="App-link"
    //       href="https://reactjs.org"
    //       target="_blank"
    //       rel="noopener noreferrer"
    //     >
    //       Learn React
    //     </a>
    //   </header>
    // </div>
    <div className='app'>
      <UserContext.Provider value={{mycontactref}}>
        <BrowserRouter>
          <Helmet>
            <title>BRIK itt Property Management</title>
            <meta name="name" content='BRIK itt Property Management' />
            <meta name='description' content='Unveil End-to-End Vacation Property Rental Management Services with BRIK itt' />
            <meta name='keywords' content='BRIK itt, brikitt, Holiday, Home, investment, Vacation, Property, Rental, Management, Services' />

            {/* Facebook Meta Tags */}
            <meta property='og:url' content='https://propertymanagement.brikitt.com/'/>
            <meta property='og:type' content='website' />
            <meta property='og:title' content='BRIK itt Property Management' />
            <meta property='og:description' content='Unveil End-to-End Vacation Property Rental Management Services with BRIK itt' />
            <meta property='og:image' content={Logo} />

            {/* Twitter Meta Tags */}
            <meta name="twitter:card" content=""/>
            <meta name="twitter:title" content='BRIK itt Property Management'/>
            <meta name="twitter:description" content='Unveil End-to-End Vacation Property Rental Management Services with BRIK itt'/>
            <meta name="twitter:image" content={Logo} />

          </Helmet>
          <Paths />
          <ToastContainer />
        </BrowserRouter>
        </UserContext.Provider>
    </div>
    
  );
}

export default App;
